const internals = {};

internals.canBypassProfileRoleInteractions = (rolePermissions = {}) => {

    return !!(
        rolePermissions.canBatchNotify ||
        rolePermissions.canPreapprove ||
        rolePermissions.canCreateGroups ||
        rolePermissions.canEditGroups ||
        rolePermissions.canSeeAllGroups ||
        rolePermissions.canViewDashboard
    );
};

internals.userDetailsForProfile = (props, propName, componentName) => {

    const userDetails = props[propName];

    if (!userDetails || !userDetails.user) {
        return new Error(`${componentName} is waiting for ${propName}`);
    }

    return null;
};

internals.targetUserRoleForProfile = (props, propName, componentName) => {

    const targetUserRole = props[propName];
    const userDetails = props.userDetails;

    if (userDetails?.isMe) {
        return null;
    }

    if (!targetUserRole) {
        return new Error(`${componentName} is waiting for ${propName}`);
    }

    return null;
};

internals.rolesInteractionsForProfile = (props, propName, componentName) => {

    const rolesInteractions = props[propName];
    const targetUserRole = props.targetUserRole;
    const userDetails = props.userDetails;

    if (userDetails?.isMe || internals.canBypassProfileRoleInteractions(props.rolePermissions)) {
        return null;
    }

    if (!Array.isArray(rolesInteractions) || !targetUserRole) {
        return new Error(`${componentName} is waiting for ${propName}`);
    }

    const hasTargetRoleInteraction = rolesInteractions.some(({ id }) => id === targetUserRole.id);

    if (!hasTargetRoleInteraction) {
        return new Error(`${componentName} is waiting for ${propName} to include the viewed user's role`);
    }

    return null;
};

exports.canBypassProfileRoleInteractions = internals.canBypassProfileRoleInteractions;

exports.dependencyPropTypes = {
    userDetails: internals.userDetailsForProfile,
    targetUserRole: internals.targetUserRoleForProfile,
    rolesInteractions: internals.rolesInteractionsForProfile
};

if (process.env.NODE_ENV === 'test') {
    exports._internals = internals;
}
